import { ThemeProvider } from "@amzn/storm-ui";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

const rootEl = document.getElementById("cdb-root");
if (rootEl) {
    const root = ReactDOM.createRoot(rootEl);

    root.render(
        <ThemeProvider>
            <HashRouter>
                <App />
            </HashRouter>
        </ThemeProvider>,
    );

    reportWebVitals();
}
